<template>
    <div class="d-flex flex-row align-center u-width-100">
        <Clamp
            v-bind="$attrs"
            ref="clamp"
            tag="div"
            class="flex-grow-1"
            :expanded="expanded"
            :max-lines="1"
            auto-resize
            @clampchange="onClampChangeDo">
            <slot></slot>
        </Clamp>
        <template v-if="expanded || clamped">
            <IconMinus
                v-if="expanded"
                class="u-mouse-pointer"
                @click="toggle" />
            <IconPlus
                v-else
                class="u-mouse-pointer"
                @click="toggle" />
        </template>
    </div>
</template>

<script>
import { IconMinus, IconPlus } from '@assets';
import Clamp from './Clamp';

export default {
    name: 'ClampToggle',
    components: {
        Clamp,
        IconMinus,
        IconPlus,
    },
    data() {
        return {
            expanded: false,
            clamped: true,
        };
    },
    methods: {
        onClampChangeDo(clamped) {
            this.clamped = clamped;
        },
        toggle() {
            this.expanded = !this.expanded;
        },
    },
};
</script>
